import styled from "styled-components"

export default function OrderDetailInfoSection({ children }) {
  return (
    <Section>
      <Title>주문 상세정보</Title>
      {children}
    </Section>
  )
}

const Section = styled.div`
  padding-top: calc(100vw * (33 / 375));
  padding-bottom: calc(100vw * (36 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-left: calc(100vw * (17 / 375));
`

const Title = styled.h2`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26 / 375));
  margin-bottom: calc(100vw * (34 / 375));
`
